export default __webpack_public_path__ + "static/media/01_Business-PortraitArchitecture-InteriorEschweilerPhotography_M1A6708.c92064bb.jpg";